<template>
  <div>
    <q-table
      style="max-height: 500px;height: calc(100%)"
      class="full-width rounded-borders sticky-header-table sticky-column-table shadow-none"
      :data="tableData"
      :columns="columnDef"
      :loading="loading"
      row-key="groupName"
      :rows-per-page-options="[0]"
      separator="cell"
      hide-bottom
    >
      <template v-slot:top>
        <div class="full-width row justify-between">
          <div style="font-size: 1rem; font-weight: bold">
            各行业已完成样本数量的区域分布
          </div>

          <div class="text-caption">
            <a class="cursor-pointer text-primary">
              查看全部样本的行业分布
              <q-menu
                max-height="90vh"
                :offset="[0, 5]"
                anchor="bottom right"
                self="top right"
              >
                <q-card
                  style="width: 360px;  box-shadow: none !important"
                  class="q-pa-md"
                >
                  <q-list>
                    <q-item
                      dense
                      v-for="[name, count] in all"
                      :key="name"
                      class="row no-wrap justify-between items-center text-caption"
                    >
                      <span>{{ name }}</span>
                      <span>{{ count }}</span>
                    </q-item>
                  </q-list>
                </q-card>
              </q-menu>
            </a>
          </div>
        </div>
      </template>
      <template v-slot:no-data="{ icon, message, filter }">
        <Empty />
      </template>
    </q-table>
  </div>
</template>

<script>
import { aggAreaAndIndustry } from "@/api/endpoints/agg/aggAreaAndIndustry";

import AggMixin from "./agg.mixin";
const all = [
  ["制造业", 1380],
  ["居民服务、修理和其他服务业", 1510],
  ["交通运输、仓储和邮政业", 319],
  ["批发和零售业", 1401],
  ["信息传输、软件和信息技术服务业", 1421],
  ["文化、体育和娱乐业", 555],
  ["租赁和商务服务业", 496],
  ["住宿和餐饮业", 323],
  ["建筑业", 663],
  ["科学研究和技术服务业", 1113],
  ["卫生和社会工作", 22],
  ["教育", 35],
  ["水利、环境和公共设施管理业", 47],
  ["房地产业", 281],
  ["金融业", 92],
  ["农、林、牧、渔业", 317],
  ["电力、热力、燃气及水生产和供应业", 22],
  ["采矿业", 4],
];
all.sort((i1, i2) => i2[1] - i1[1]);
export default {
  mixins: [AggMixin],
  components: {
    Loading: () => import("@/components/Loading"),
    Empty: () => import("@/components/Empty"),
  },

  data() {
    return {
      tableData: [],
      data: [],
      loading: false,
      columnDef: [],

      all,
    };
  },

  methods: {
    agg() {
      this._aggAreaAndIndustry();
    },
    async _aggAreaAndIndustry() {
      try {
        this.loading = true;
        const response = await aggAreaAndIndustry();
        if (!response || response.status || response.error)
          throw Error(response.detail || response.message);
        this.data = response;
        this.renderTable();
      } catch (err) {
        console.log(err);
        this.$q.notify({ type: "danger", messahe: err.toString() });
      } finally {
        this.loading = false;
      }
    },

    renderTable() {
      const colKey = "区域";
      const rowKey = "行业";
      const valKey = "数量";

      const colCates = Object.keys(
        this.data.reduce((dict, row) => {
          dict[row[colKey]] = 1;
          return dict;
        }, {})
      );
      const rowCates = Object.keys(
        this.data.reduce((dict, row) => {
          dict[row[rowKey]] = 1;
          return dict;
        }, {})
      );
      const tableData = rowCates.map((cate) => {
        const filled = this.data
          .filter((row) => row[rowKey] === cate)
          .reduce(
            (res, record) => {
              res[record[colKey]] = record[valKey];
              return res;
            },
            {
              [rowKey]: cate,
            }
          );
        colCates.forEach((col) => {
          filled[col] = filled[col] || "0";
        });
        return filled;
      });
      this.tableData = tableData.map((row) => {
        const sumOfRow = Object.keys(row).reduce((sum, key) => {
          return sum + (parseInt(row[key]) || 0);
        }, 0);
        const rowVal = row[rowKey];
        const totalRow = all.find((el) => el[0] === rowVal)[1];
        return {
          ...row,
          [rowKey]: `${rowVal}（${totalRow}）`,
          sum_row: `${sumOfRow}（${((sumOfRow / totalRow) * 100).toFixed(2)}%）`,
        };
      });
      console.log(this.tableData);
      this.columnDef = [
        {
          name: rowKey,
          field: rowKey,
          label: "行业\\区域",
          align: "center",
        },
        {
          name: "sum_row",
          field: "sum_row",
          label: "合计(占比)",
          align: "center",
        },
      ].concat(
        colCates.map((cate) => ({
          name: cate,
          field: cate,
          label: cate,
          align: "center",
        }))
      );
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/quasar";
.sticky-header-table {
  thead tr th {
    position: sticky;
    z-index: 3 !important;
  }

  .q-table__middle.scroll {
    overflow: hidden;
  }
  &:hover {
    .q-table__middle.scroll {
      overflow: auto;
    }
  }
}
.sticky-column-table {
  /* specifying max-width so the example can
    highlight the sticky column on any browser window */

  thead tr:first-child th:first-child {
    background-color: #fff;
  }

  td:first-child {
    font-weight: bold;
    background-color: $grey-2;
  }

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    z-index: 1;
  }
}
</style>
